<template>
  <v-layout fill-height>
    <v-flex fill-height class="header">
      <div class="d-flex flex-row page-header formlittle mb-3">
        <h1>{{nbCatalogs}} catalogues</h1>
        <v-spacer></v-spacer>
        <v-checkbox label="voir les archives" v-model="showArchive" class="mr-4"></v-checkbox>
        <v-btn
          v-if="$store.state.myrights.create_catalogue"
          @click="newCatalog"
          class="primary2"
          depressed
        >Créer un nouveau catalogue</v-btn>
      </div>
      <v-alert
        v-if=" $moment().isBefore($moment('2021-05-15'))"
        border="left"
        color="#7bbff6"
        type="info"
        class="uppercase"
      > Nouveau : vous pouvez personnaliser les traductions dans chaque catalogue.</v-alert>
      <v-alert
        v-if="isDevOrNot()"
        border="left"
        color="red"
        type="info"
        class="uppercase"
      > Serveur de développement. Vous devez utiliser : <a style="color:white;" href="https://catalogues.rozenbal.fr">https://catalogues.rozenbal.fr/</a>.</v-alert>
      <v-card class="fill-height overflow-auto" flat>
        <v-card-text>
          <catalogs-list
            @catalogsLoaded="catalogsLoaded"
            ref="cataloglist"
            :showArchive="showArchive"
          ></catalogs-list>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "offers",
  data() {
    return {
      showArchive: false,
      nbCatalogs: 0
    };
  },
  // filters: {},
  watch: {
    $route(to, from) {}
  },
  computed: {},
  components: {},
  async mounted() {},
  destroyed() {},
  methods: {
    isDevOrNot(){
      if (window.location.host=='catalogues.rozenbal.fr') return false;
      return true;
    },
    newCatalog() {
      this.$router.push("/catalogs/edit/-1");
    },
    catalogsLoaded(nbCatalogs) {
      this.nbCatalogs = nbCatalogs;
    }
  }
};
</script>
<style  lang="scss" scoped>
</style>